import React, { PropsWithChildren } from 'react';
import {
  CardHeader as ChakraUICardHeader,
  Stack,
  StackDirection,
  CardHeaderProps as ChakraCardHeaderProps,
} from '@chakra-ui/react';

interface CardHeaderProps extends Omit<ChakraCardHeaderProps, 'children'>, PropsWithChildren {
  stackDirection?: StackDirection;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ stackDirection = 'column', children, ...rest }) => {
  const computedProps = {
    direction: stackDirection,
    spacing: 2,
    ...(stackDirection === 'row' && {
      justify: 'space-between',
      align: 'baseline',
    }),
  };

  /**
   * DOM
   */
  return (
    <ChakraUICardHeader {...rest} data-object-type="core-card-header">
      <Stack {...computedProps}>{children}</Stack>
    </ChakraUICardHeader>
  );
};
